<template>
  <div>
    <base-box class="no-shadow px_15" :class="!isMobile && 'mb_20'">
      <div class="results d-flex">
        <div class="d-flex flex-column">
          <p>
            {{ Utils.convertMoney((results.sales || 0).toFixed(2)) }}
          </p>
          <p>Valor em Vendas</p>
        </div>
        <div class="vertical-line"></div>
        <div class="d-flex flex-column">
          <p>
            {{ Utils.convertMoney((results.average || 0).toFixed(2)) }}
          </p>
          <p>Ticket Médio</p>
        </div>
      </div>
      <div class="horizontal-line mb_20"></div>
      <div class="funnels d-flex align-center">
        <div
          @click="openDrawer('Público', getTargetUsers)"
          class="funnel w-100"
        >
          <div class="funnel-values">
            <p class="mb_5">{{ campaign.total_users || 0 }}</p>
            <p>Público</p>
          </div>
        </div>
        <div class="funnel-line"></div>
        <div
          @click="openDrawer('Cliques', getTargetUsersClicks)"
          class="funnel w-100"
        >
          <div class="funnel-values">
            <p class="mb_5">{{ campaign.total_clicks || 0 }}</p>
            <p>Cliques</p>
          </div>
        </div>
        <div class="funnel-line"></div>
        <div
          @click="openDrawer('Usos', getUsersCouponUses)"
          class="funnel w-100"
        >
          <div class="funnel-values">
            <p class="mb_5">{{ results.total || 0 }}</p>
            <p>Usos</p>
          </div>
        </div>
      </div>
    </base-box>

    <base-drawer
      ref="usersDrawer"
      :open="drawer.open"
      :close="drawer.close"
      :title="drawer.title"
      @onClose="drawer.show = false"
    >
      <base-card>
        <base-input
          placeholder="Pesquisar clientes"
          class="mb_0 w-100"
          v-model="term"
          @input="isTyping = true"
          autocomplete="none"
        />
      </base-card>
      <base-card
        v-for="(user, i) in users"
        :key="i"
        class="d-flex align-center justify-between users-card"
      >
        <div class="d-flex align-center users-info">
          <span class="d-flex align-center justify-center mr_15"
            ><i class="fas fa-user"></i
          ></span>
          <div>
            <p class="mb_5">{{ user.name || StringLanguage.customerNotAssigned }}</p>
            <p class="mb_5">{{ user.order_id || user.phone }}</p>
            <p>{{ user.order_total || user.email }}</p>
          </div>
        </div>
        <p>{{ getArrivedTime(user.order_date) }}</p>
      </base-card>
      <infinite-loading
        v-if="drawer.show && users.length > 0"
        spinner="wavedots"
        @infinite="infiniteHandler"
      >
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </base-drawer>
  </div>
</template>
<script>
import BaseBox from "@/components/Box";
import BaseLabel from "@/components/Label";
import BaseDrawer from "@/components/Drawer";
import BaseCard from "@/components/Card";
import BaseInput from "@/components/Input";
import BaseButton from "@/components/Button";

import MarketingAPI from "@/api/marketing";
import ApiReports from "@/api/reports";

import Utils from "@/utils";

import { mapState } from "vuex";
import InfiniteLoading from "vue-infinite-loading";

export default {
  data() {
    return {
      Utils,
      users: [],
      isTyping: false,
      page: 0,
      size: 10,
      term: "",
      drawer: {
        title: "",
        open: false,
        close: false,
      },
    };
  },
  props: {
    campaign: { type: Object, default: () => ({}), required: true },
    couponCode: { type: String },
    results: { type: Object, default: () => ({}), required: true },
    period: { type: Array, default: () => [] },
  },
  methods: {
    openDrawer(drawerTitle, getUsers) {
      if (this.drawer.title != drawerTitle) {
        this.page = 0;
        this.users = [];
        this.drawer.title = drawerTitle;
        this.drawer.getUsers = getUsers;
        getUsers && getUsers();
      }

      this.drawer.show = true;
      this.drawer.open = !this.drawer.open;
    },
    getTargetUsers(reset = false) {
      if (reset) {
        this.users = [];
        this.page = 0;
      }

      return MarketingAPI.campaignTargetUsers(
        this.campaign.id,
        this.term,
        this.page
      ).then((response) => {
        const users = response.getData({}).campaignUsers || [];
        if (users.length > 0) {
          this.users.push(...users);
          this.page++;
          return true;
        }
        return false;
      });
    },
    getTargetUsersClicks(reset = false) {
      if (reset) {
        this.users = [];
        this.page = 0;
      }

      return MarketingAPI.campaignTargetUsersClicks(
        this.campaign.id,
        this.term,
        this.page
      ).then((response) => {
        const users = response.getData({}).campaignUsersClicks || [];
        if (users.length > 0) {
          this.users.push(...users);
          this.page++;
          return true;
        }
        return false;
      });
    },
    getUsersCouponUses(reset = false) {
      if (reset) {
        this.users = [];
        this.page = 0;
      }

      return ApiReports.reports(this.esDataFilter).then((response) => {
        if (response.data[0]) {
          const data = response.data[0];
          if (data.hits.length > 0) {
            this.page += 1;

            data.hits.forEach((item) => {
              const {
                order_id,
                total_amount: order_total,
                created_at: order_date,
                payers,
              } = item._source;
              const { id, phone, name } = payers[0].user || {};
              this.users.push({
                id,
                name,
                phone,
                order_id: `#${order_id}`,
                order_total: Utils.convertMoney(order_total),
                order_date,
              });
            });

            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
    },
    getArrivedTime(date) {
      if (!date) return "";

      const milliseconds = Utils.toMilliseconds(date);
      var temp = Math.floor(milliseconds / 1000);
      var days = Math.floor((temp %= 31536000) / 86400);

      if (days) {
        return Utils.dateParse(date).replace(" ", " (") + ")";
      }

      return `${Utils.millisecondsToStr(milliseconds)}`;
    },
    async infiniteHandler($state) {
      const result = await this.drawer.getUsers();
      if (result) {
        $state.loaded();
      } else {
        $state.complete();
      }
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
    wasDivulgationSent() {
      return !!this.campaign.last_run;
    },
    esDataFilter() {
      let queries = [
        {
          range: {
            created_at: {
              gte: this.period[0],
              lte: this.period[1],
            },
          },
        },
        {
          bool: {
            should: [
              {
                match: {
                  status: 4,
                },
              },
              {
                match: {
                  status: -1,
                },
              },
            ],
          },
        },
      ];

      if (this.term != "") {
        const termIsNumber = /^\d+$/.test(this.term);

        if (termIsNumber) {
          queries.push({
            nested: {
              path: "payers",
              query: {
                query_string: {
                  query: `*${this.term.toLowerCase()}*`,
                  fields: ["payers.user.phone"],
                },
              },
            },
          });
        } else {
          // transoforma o nome em caixa baixa e substitui os espaços por '*'
          const queryName = this.term.toLowerCase().replace(/\s/g, "*");
          queries.push({
            nested: {
              path: "payers",
              query: {
                query_string: {
                  query: `*${queryName}*`,
                  fields: ["payers.user.name"],
                },
              },
            },
          });
        }
      }

      queries.push({
        query_string: {
          query: this.couponCode,
          fields: ["gift.code"],
        },
      });

      return {
        query: [
          {
            index: "report-orders",
            type: "query",
            size: this.size,
            from: this.page * this.size,
            queries: queries,
          },
        ],
      };
    },
  },
  watch: {
    term: Utils.debounce(function() {
      this.isTyping = false;
    }, 1000),
    isTyping: function(value) {
      if (!value) {
        this.drawer.getUsers(true);
      }
    },
  },
  components: {
    BaseBox,
    BaseButton,
    BaseLabel,
    BaseDrawer,
    BaseCard,
    BaseInput,
    InfiniteLoading,
  },
};
</script>

<style scoped>
.results {
  justify-content: space-around;
  margin-bottom: 25px;
}
.results div p:first-child {
  background: var(--background-up);
  padding: 5px 20px;
  text-align: center;
  font-size: 1.8em;
  font-weight: 900;
  line-height: 22px;
  color: #0dc59de3;
  border-radius: 5px;
  margin-bottom: 5px;
}
.results div p:last-child {
  text-align: center;
  font-size: 1.4em;
  color: #aaaaaacc;
}
.funnel {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(69 72 77 / 48%);
  border-radius: 5px;
}
.funnel-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #8c8c8ca3;
  margin-right: 15px;
}
.funnel-icon i {
  color: var(--box);
  font-size: 1.4em;
}
.funnel-values {
  display: flex;
  flex-direction: column;
  padding: 10px;
  text-align: center;
}
.funnel-values p:first-child {
  font-size: 1.6em;
  font-weight: 900;
  color: var(--default);
}
.funnel-values p:last-child {
  font-size: 1.2em;
  color: #999999;
}
.vertical-line {
  border-right: 1px solid #ffffff4d;
  height: 75px;
  position: absolute;
  top: 10px;
}
.horizontal-line {
  border-top: 1px solid #ffffff4d;
  width: 100%;
}
.funnel-line {
  border-top: 2px dotted #99999973;
  width: 62px;
}
.users-card p {
  font-size: 1.2em;
  font-weight: 300;
  color: var(--input-text);
}
.users-info span {
  width: 33px;
  height: 33px;
  background: #0000001a;
  border-radius: 50%;
  font-size: 1.4em;
  color: var(--label-secondary);
}
.users-info div p:first-child {
  font-size: 1.4em;
  color: #999999;
}
@media screen and (max-width: 991px) {
  .results div p:first-child {
    font-size: 1.6em;
    margin-bottom: 5px;
  }
  .results div p:last-child {
    font-size: 1.2em;
  }
  .funnel-values p:first-child {
    font-size: 1.4em;
  }
  .funnel-values p:last-child {
    font-size: 1em;
    text-transform: uppercase;
  }
  .funnel-line {
    width: 30px;
  }
  .funnel {
    background: rgb(69 72 77 / 48%);
  }
}
@media (max-width: 380px) {
  .funnels {
    flex-direction: column;
  }
  .funnel-line {
    border-left: 1px solid #99999973;
    height: 15px;
    width: 0px;
  }
}
</style>
